/**
 * Loại Reference sinh ra ở bảng voucher_reference
 */
export default {
  /**
   * Tất cả
   */
  All: -1,

  /**
   * Chứng từ sinh thông thường
   */
  Normally: 0,

  /**
   * Sinh khi thanh toán
   */
  Pay: 1,

  /**
   * thuộc về dành cho chứng từ nhận dự toán
   */
  Belong: 2,
  /**
   * thuộc về dành cho chứng từ nhận dự toán khi bỏ ghi thì chuyển thành để ghi sổ lại
   */
  OldBelong: 3,
};
